import { Mixins, Component, Prop } from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/exam';
import { ExamTypeEnum } from '@/libs/config';
import pageMixin from '../../../mixins/pageMixin';

@Component
export default class tableMixin extends Mixins(pageMixin) {
  private cList: any = []; // 试题列表数据
  private cLists: any = []; // 题库详情数据
  @Prop({
    type: String,
    default: String,
  }) sid!: string;

  private column: Array<ITABLECOLCONF> = [{
    label: '试题编号',
    prop: 'serial',
    align: 'center',
    width: '150px',
    tooltip: true,
  },{
    label: '题目类型',
    prop: 'type.name',
    align: 'center',
    width: '150px',
    tooltip: true,
    // formatter: (row: any) => ExamTypeEnum[row.worType],
  }, {
    label: '归属题库',
    prop: 'subject',
    align: 'left',
    tooltip: true,
  }, {
    label: '知识点',
    prop: 'knowledge',
    align: 'left',
    tooltip: true,
  },
  {
    label: '创建时间',
    prop: 'createAt',
    align: 'center',
    width: '150px',
  }, {
    label: '操作',
    custom: true,
    minWidth: '120px',
    align: 'center',
    maxBtn: 2,
    btnList: [
      {
        title: '修改',
        name: '/wor/manage:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleEdit,
        log: {
          name: '试题管理 - 修改',
          component: '/wor/manage:update',
        },
      },
      {
        title: '预览',
        name: '/wor/manage:priew',
        icon: 'info',
        type: 'info',
        callback: this.priewTestQues,
        log: {
          name: '试题管理 - 预览',
          component: '/wor/manage:priew',
        },
      },
      {
        title: '删除',
        name: '/wor/manage:remove',
        icon: 'remove',
        type: 'info',
        callback: this.handleRemove,
        log: {
          name: '试题管理 - 删除',
          component: '/wor/manage:remove',
        },
      },
    ],
  }]

  private loading: boolean = false;

  created() {
    if (this.sid === '') {
      this.getPageTestQues();
    } else {
      this.getQuesBankDetail();
    }
  }

  // 分页查询所有试题
  getPageTestQues(params?: any) {
    this.loading = true;
    this.page.params = params;
    const data = { pageSize: this.page.pageSize, pageNo: this.page.pageNo, ...this.page.params };
    api.pageGetTestQues(data).then((res: any) => {
      this.cList = res.content;
      this.total = res.totalElements;
      this.loading = false;
    });
  }

  // 查询该题库所有试题
  getQuesBankDetail() {
    const pages = {
      pageNo: this.page.pageNo,
      pageSize: this.page.pageSize,
      id: this.sid,
      ...this.page.params
    };
    api.quesBankDetail(this.sid).then((res: any) => {
      this.cLists = res.content;
      this.total = res.totalElements;
      this.loading = false;

    })
  }

  handleEdit(row: any) {
  }

  priewTestQues(row: any) {

  }

  /**
   * @author liuyongchun
   * @desc 删除试题
   * @params { any } row 行数据
   */
  handleRemove(row: any) {
    this.confirm('你确定要删除该试题吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeTestQues(row.id).then(() => {
        this.getPageTestQues();
        close();
        this.$log({
          title: '试题管理 - 删除 - 确定',
          component: 'trial/manage/bModal',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '试题管理 - 删除 - 取消',
      component: 'trial/manage/bModal',
    }));
  }
}
